module.exports = __webpack_public_path__ + "static/media/shalust.b3f703dd.png";